import { all, call, put, takeLatest } from "redux-saga/effects";
import userApi from "../../../api/userApi";
import {
  GET_USER_REQUEST,
  getUserFailure,
  getUserSuccess,
  LOGIN_REQUEST,
  logoutRequest,
} from "./authActions";

function* watchGetUser(action) {
  try {
    const result = yield call(async () => {
      return await userApi.get(action.payload);
    });
    if (result.status === 1) {
      yield put(getUserSuccess(result.data));
    } else {
      yield put(logoutRequest());
    }
  } catch (error) {
    yield put(logoutRequest());
  }
}

function* watchLogin(action) {
  try {
    const result = yield call(async () => {
      return await userApi.login(
        action.payload.username,
        action.payload.password
      );
    });
    if (result.status === 1) {
      localStorage.setItem("id", result.data._id);
      yield put(getUserSuccess(result.data));
    } else {
      yield put(getUserFailure(result.message));
    }
  } catch (error) {
    yield put(getUserFailure(error.response?.data?.message || error.message || "Đăng nhập thất bại"));
  }
}

function* authSaga() {
  yield all([
    takeLatest(GET_USER_REQUEST, watchGetUser),
    takeLatest(LOGIN_REQUEST, watchLogin),
  ]);
}

export default authSaga;
